import React from 'react'

// styles
import { profileContentSectionHeader } from 'styles/v2/pages/profile'

interface Props {
  title?: string
  children?: React.ReactNode
}

export const TitleProfileSection: React.FC<Props> = ({ title, children }) => {
  return (
    <div className={profileContentSectionHeader}>
      {children ? (
        children
      ) : (
        <span className="cl-text-secondary fw-md fs-18">{title}</span>
      )}
    </div>
  )
}
